import React, { useState } from 'react';
import './index.css';
import Login from './pages/Login';
import TutorDashboard from './pages/TutorDashboard';
import StudentPortal from './pages/StudentPortal';
import ParentPortal from './pages/ParentPortal';
import LiveSession from './pages/LiveSession';
import { supabase } from './lib/supabase';

export default function App() {
  const [auth, setAuth] = useState(null); // { role, studentId, studentName }
  const [liveSession, setLiveSession] = useState(null);

  const handleLogin = (authData) => setAuth(authData);
  const handleLogout = () => { setAuth(null); setLiveSession(null); };

  const handleStartSession = async (student) => {
    // Always end any previous active sessions for this student first
    await supabase.from('live_sessions').update({ active: false }).eq('student_id', student.id).eq('active', true);

    // Create a fresh session — fresh whiteboard every time
    const { data } = await supabase
      .from('live_sessions')
      .insert([{ student_id: student.id, student_name: student.name, active: true, whiteboard_locked: false }])
      .select()
      .single();

    // Clear old whiteboard strokes for this student's sessions so the board is blank
    if (data) {
      await supabase.from('whiteboard_strokes').delete().eq('session_id', data.id);
    }

    setLiveSession({ ...data, student_name: student.name });
  };

  const handleEndSession = () => setLiveSession(null);

  if (!auth) return <Login onLogin={handleLogin} />;

  if (liveSession) {
    return (
      <LiveSession
        sessionData={liveSession}
        role={auth.role}
        studentName={auth.studentName || liveSession.student_name}
        studentId={auth.studentId || liveSession.student_id}
        onEnd={handleEndSession}
      />
    );
  }

  if (auth.role === 'tutor') {
    return <TutorDashboard onStartSession={handleStartSession} onLogout={handleLogout} />;
  }

  if (auth.role === 'student') {
    return (
      <StudentPortal
        studentId={auth.studentId}
        studentName={auth.studentName}
        onJoinSession={(session) => setLiveSession(session)}
        onLogout={handleLogout}
      />
    );
  }

  if (auth.role === 'parent') {
    return (
      <ParentPortal
        studentId={auth.studentId}
        studentName={auth.studentName}
        onLogout={handleLogout}
      />
    );
  }

  return null;
}
